import React, { useContext } from "react";
import { Controller, useWatch } from "react-hook-form";
import { Button, Dialog } from "iuvity-ui-components";
import { MultiSelect } from "primereact/multiselect";
import { DialogProps } from "../dialog/CustomDialog";
import { AppContext } from "../../context/index";
import { TranslationsSchema } from "../../validations/schemas";
import { REVALIDATE_FORM_PROPS } from "../../constants";

interface FilterDialogProps extends DialogProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  onClearFilters: Function;
  form: any;
  formOptions: any;
}

export const FilterDialog: React.FC<FilterDialogProps> = ({
  visible,
  setVisible,
  data,
  setData,
  onClearFilters,
  form,
  formOptions,
}) => {
  const {
    t,
    appState: { pageFilter },
    setAppState,
  } = useContext(AppContext);
  const { control, setValue } = form;

  const functionalityValues = useWatch({
    control: form.control,
    name: "functionality",
  });

  const typesValues = useWatch({
    control: form.control,
    name: "type",
  });

  const versionsValues = useWatch({
    control: form.control,
    name: "version",
  });

  const onCloseModal = () => {
    setVisible(false);
  };

  const onFilter = () => {
    const formValues = form.getValues();
    setData(
      data.filter(
        (item: any) =>
          (functionalityValues.length > 0
            ? item.widgets.some(
                (wid: any[]) => functionalityValues.indexOf(wid) !== -1
              )
            : true) &&
          (typesValues.length > 0 ? typesValues.includes(item.type) : true) &&
          (versionsValues.length > 0
            ? versionsValues.includes(item.releaseversion)
            : true)
      )
    );
    setVisible(false);
    form.reset(formValues);
    if (JSON.stringify(formValues) !== JSON.stringify(pageFilter)) {
      setAppState((prev) => ({
        ...prev,
        pageFilter: formValues,
      }));
    }
  };

  const renderFooter = () => {
    return (
      <div className="flex align-items-center justify-content-flex-end">
        <Button
          className="mr-4"
          label={t("Translations.clearFilterBtnLabel")}
          variant="p-button-link"
          onClick={() => onClearFilters()}
        />
        <Button
          label={t("Translations.filterBtnLabel2")}
          variant="p-button"
          disabled={
            !(
              functionalityValues.length > 0 ||
              typesValues.length > 0 ||
              versionsValues.length > 0
            )
          }
          onClick={onFilter}
        />
      </div>
    );
  };

  return (
    <Dialog
      id="dialogScroll1T"
      className="dialog-form"
      header={t("Translations.filterDialogTitle")}
      visible={visible}
      onHide={onCloseModal}
      style={{ width: "35rem" }}
      footer={renderFooter}
    >
      <div className="form lg">
        {["functionality", "type", "version"].map((key) => {
          return (
            <div key={key}>
              <Controller
                name={key}
                control={control}
                rules={(TranslationsSchema(t) as any)[key]}
                render={({ field }) => {
                  field.onChange = (e) => {
                    setValue(field.name, e.value, REVALIDATE_FORM_PROPS);
                  };
                  return (
                    <>
                      <label htmlFor={key} className="block lb mt-2 mb-1">
                        {t(`Translations.${key}Label`)}
                      </label>
                      <MultiSelect
                        id={`select-widget`}
                        display="chip"
                        placeholder={t(
                          `Translations.${key}PlaceholderFilterLabel`
                        )}
                        className="mb-4"
                        options={formOptions[key]}
                        filter
                        emptyFilterMessage={t(
                          "Translations.noAvailableMessage"
                        )}
                        {...field}
                      />
                    </>
                  );
                }}
              />
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};